import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box
} from '@mui/material';

const AddTermDialog = ({
  open,
  onClose,
  newTerm,
  onNewTermChange,
  onSubmit,
  subjects
}) => {
  const handleChange = (field) => (event) => {
    onNewTermChange({
      ...newTerm,
      [field]: event.target.value
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>새 용어 추가</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <FormControl fullWidth>
            <InputLabel>과목</InputLabel>
            <Select
              value={newTerm.subject}
              onChange={handleChange('subject')}
              label="과목"
            >
              {subjects.map(subject => (
                <MenuItem key={subject} value={subject}>
                  {subject}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="용어"
            value={newTerm.term}
            onChange={handleChange('term')}
          />

          <TextField
            fullWidth
            multiline
            rows={4}
            label="정의"
            value={newTerm.definition}
            onChange={handleChange('definition')}
          />

          <TextField
            fullWidth
            label="키워드 (쉼표로 구분)"
            value={newTerm.keywords}
            onChange={handleChange('keywords')}
            helperText="키워드는 쉼표(,)로 구분하여 입력하세요"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>취소</Button>
        <Button 
          onClick={onSubmit} 
          variant="contained" 
          disabled={!newTerm.subject || !newTerm.term || !newTerm.definition}
        >
          추가
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTermDialog; 